if (!customElements.get('product-card-information')) {
  customElements.define(
    'product-card-information',
    class ProducCardtInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.productUrl = '';
        this.available = true;
        this.that = this;
        this.clearVariantsChoise();
      }

      clearVariantsChoise() {
        let fieldsSets = this.that.querySelectorAll('input[type="radio"]:checked');
        fieldsSets.forEach(elem => {
          elem.checked = false;
        });
      }

      connectedCallback() {
        

        // let checkedInputs = this.querySelectorAll('input[type="radio"]:checked');
        // let fieldsSets = this.querySelectorAll('fieldset');
        
        // if ( checkedInputs.length === fieldsSets.length ) {
          this.initializeProductSwapUtility();
          this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            this.handleOptionValueChange.bind(this)
          );
          
          // this.initQuantityHandlers();
          this.dispatchEvent(new CustomEvent('product-card-information:loaded', { bubbles: true }));
        // }

        
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      // initQuantityHandlers() {
      //   if (!this.quantityInput) return;

      //   this.quantityForm = this.querySelector('.product-form__quantity');
      //   if (!this.quantityForm) return;

      //   this.setQuantityBoundries();
      //   if (!this.dataset.originalSection) {
      //     this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      //   }
      // }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl; // f
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct; // f

        this.productUrl = productUrl;
        // console.log(55, productUrl, selectedOptionValues)

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct  // true / false
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          // const selector = updateFullPage ? "product-card-information[id^='CardProduct']" : 'product-card-information';
          const selector = `#${this.id}`;
          const variant = this.getSelectedVariant(html.querySelector(selector));
          //this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector(`#${this.id}`),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      reloadGallery() {
        let urlProduct = this.productUrl.split('/products/')[1];
        urlProduct = urlProduct.split('?')[0];
        let urlTemplate = '';
        // took product data from 'product.metafields-small-images.liquid' template for 'complementary' products
        if(this.dataset['card'] == 'complementary'){
          urlTemplate = 'metafields-small-images'
        } else {
          urlTemplate = 'metafields';
        }

        let varId = this.closest('.card__content');
        if ( varId ) {
          varId = varId.querySelector('.product-variant-id').value;
        } else {
          varId = 0;
        }
        let $this = this;
        

        fetch(`/products/${urlProduct}?view=${urlTemplate}&variant=${varId}`)
        .then((response) => response.text())
        .then((responseText) => {
          // let data = JSON.parse(responseText);
          // debugger;
          let cardProduct = $this.closest(`[data-handle="${decodeURIComponent(urlProduct)}"]`);
          let variantId = cardProduct?.querySelector('.product-variant-id').value;
          
          
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          
         

          let newGallery = html.querySelector(`.slider--card[data-variant-id="${variantId}"]`);
          // debugger;
          let containerForChange = cardProduct?.querySelector('.slider--card.swiper');
          if ( containerForChange && newGallery) {
            containerForChange.innerHTML = newGallery.innerHTML;
            containerForChange.classList.remove('swiper-initialized');
          }
          
          window?.sliderProductCard();

           let variantSelects = html.querySelectorAll('.card__information-left');
          if ( variantSelects ) {
            console.log(2222, variantSelects);
            
            let oldVariants = cardProduct?.querySelector('.card__information-left');
            console.log(oldVariants);
            if ( oldVariants ) {
              oldVariants.innerHTML = variantSelects[0].innerHTML;
            }

            let fieldsSets = oldVariants.querySelectorAll('.product-form__input.product-form__input--pill input[type="radio"]:checked');
            console.log(fieldsSets);
            fieldsSets.forEach(elem => {
              elem.checked = false;
            });
          }
        });
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            // document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }




      getSelectedVariant(productInfoNode) {
        let container = this.that;
        let wrapperContainer = container.closest('.product-card-wrapper');
        let dataVariants = wrapperContainer.querySelector('[data-product-full-info]');
        let variants = JSON.parse(dataVariants.innerHTML);
        let fieldsSets = container.querySelectorAll('input[type="radio"]:checked');
        
        if ( fieldsSets.length == 0 ) {
          fieldsSets = container.querySelectorAll('select');
        }
        let filterValues = [];
        fieldsSets.forEach(elem => {
          filterValues.push(elem.value);
        });

        const filteredItems = variants.filter(item => 
          filterValues.every(value => item.options.includes(value))
        );
        // console.log(filteredItems);
        this.available = filteredItems[0].available;
        return filteredItems[0];
        
      }


      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) { // OK
        let  variantSelects = html.querySelector(`#${this.id} variant-selects`);
        // console.log(html);
        variantSelects = null;
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          
          const variant = this.getSelectedVariant(html);
          
          
          // debugger;
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          // this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          let currentId = this.querySelector('.product-variant-id');
          // console.log(currentId);
          if ( currentId && variant.id ) {
            currentId.value = variant.id;
          }
          
          
          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.reloadGallery();

          //this.updateMedia(html, variant?.featured_media?.id);

          const hideQuickView = () => {
            let quick = this.querySelector('.product-card__quick-add');
            let buyButton = this.querySelector('.js-add-to-cart');

            if ( buyButton.closest('.complementary_card_product') ) return false;
            
            let checkedInputs = this.querySelectorAll('input[type="radio"]:checked');
            let fieldsSets = this.querySelectorAll('fieldset');

            if ( ! ( quick && buyButton) ) return false;

            if ( !this.available && checkedInputs.length === fieldsSets.length ) {
              quick.classList.remove('hidden');
              buyButton.classList.add('hidden');
              let btnQuick = quick.querySelector('[type="submit"]');
              btnQuick.click();
              this.clearVariantsChoise(this);
              checkedInputs[0]?.closest('.card__content')?.querySelector('span.message').classList.add('hidden');
            } else if ( checkedInputs.length === fieldsSets.length ) {
              quick.classList.add('hidden');
              buyButton.classList.remove('hidden');
              let btn = buyButton.querySelector('product-form');
              if ( window.innerWidth > 992 && ! buyButton.closest('.complementary_card_product') ) {
                btn.onSubmitHandlerCustom();
              }
              this.clearVariantsChoise();
              checkedInputs[0]?.closest('.card__content')?.querySelector('span.message').classList.add('hidden');
            } else if ( checkedInputs.length === 1 && checkedInputs[0].closest('.product-form__input--swatch') && window.innerWidth > 749 ) {
              checkedInputs[0]?.closest('.card__content')?.querySelector('span.message').classList.remove('hidden');
            }

          }

          hideQuickView();

          const updatePrice = () => {
            // document.getElementById('additional-price').innerText = theme.Currency.formatMoney(variant.price);
            // Shopify.formatMoney(cart.total_price).replace('$', 'currencySymbol');
            // this.querySelectorAll('.price-item--regular').innerText = Shopify.formatMoney(variant.price);
            let formatedRegularPrice = Shopify.formatMoney(variant.price);
            let regularPrices = this.querySelectorAll('[data-price-regular]');
            regularPrices.forEach(function(item){
              item.innerText = Shopify.formatMoney(variant.price);
            });
            
            if(variant.compare_at_price){
              let compareAtPrices = this.querySelectorAll('[data-compare-price]');
              compareAtPrices.forEach(function(item){
                item.innerText = Shopify.formatMoney(variant.compare_at_price);
                item.classList.remove('hidden');
              });
            } else {
              let compareAtPrices = this.querySelectorAll('[data-compare-price]');
              compareAtPrices.forEach(function(item){
                item.classList.add('hidden');
              });
            }
          }

          updatePrice();

          // const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
          //   // const source = html.getElementById(`#${this.id} ${id}-${this.sectionId}`);
          //   const source = html.querySelector(`#${this.id} #${id}-${this.sectionId}`);
          //   const destination = this.querySelector(`#${id}-${this.dataset.section}`);
          //   if (source && destination) {
          //     destination.innerHTML = source.innerHTML;
          //     destination.classList.toggle('hidden', shouldHide(source));
          //   }
          // };

          // updateSourceFromDestination('price');
          //updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          // updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          // updateSourceFromDestination('Volume');
          // updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          // this.updateQuantityRules(this.sectionId, html);
          // this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          // this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            // html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            ! this.available,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }


      // updateVariantInputs(variantId) { // buy button change Id  OK
      //   // #card-product-form-template--17396615020722__featured_collection_4Xmy7f8261992120498
      //   this.querySelectorAll(
      //     `#${this.id} #card-product-form-${this.dataset.section}${this.dataset.productId}`
      //   ).forEach((productForm) => {
      //     const input = productForm.querySelector('input[name="id"]');

      //     // console.log(88, input)
      //     input.value = variantId ?? '';
      //     input.dispatchEvent(new Event('change', { bubbles: true }));
      //   });
      // }
      
      updateVariantInputs(variantId) {

        const selectedInput = this.querySelector('input[type="radio"]:checked');
        const isOther = selectedInput && (selectedInput.value === 'אחר' || selectedInput.value === 'Other');
        if (isOther) {
            variantId = '47078516850866'; 
            
            let customAmountInput = this.closest('.product-card-wrapper')?.querySelector('input[type="number"]:not([name="quantity"])');
            
            if (!customAmountInput) {
                 customAmountInput = document.querySelector('.product-form__input--swatch input[type="number"]');
            }

            if (customAmountInput) {
               const formQtyInput = this.querySelector('input[name="quantity"]');
               
               if (formQtyInput) {
                   formQtyInput.value = customAmountInput.value;
                   
                   customAmountInput.addEventListener('input', function() {
                       formQtyInput.value = this.value;
                   });
                   
                   customAmountInput.addEventListener('change', function() {
                       formQtyInput.value = this.value;
                   });
               }
            }
        }

        this.querySelectorAll(
          `#${this.id} #card-product-form-${this.dataset.section}${this.dataset.productId}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        // this.querySelector('share-button')?.updateUrl(
        //   `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        // );

        // if (this.dataset.updateUrl === 'false') return;
        // window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      // updateMedia(html, variantFeaturedMediaId) {
      //   if (!variantFeaturedMediaId) return;

      //   const mediaGallerySource = this.querySelector('media-gallery ul');
      //   const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

      //   const refreshSourceData = () => {
      //     if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
      //     const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      //     const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      //     const sourceMap = new Map(
      //       mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
      //     );
      //     return [mediaGallerySourceItems, sourceSet, sourceMap];
      //   };

      //   if (mediaGallerySource && mediaGalleryDestination) {
      //     let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      //     const mediaGalleryDestinationItems = Array.from(
      //       mediaGalleryDestination.querySelectorAll('li[data-media-id]')
      //     );
      //     const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      //     let shouldRefresh = false;

      //     // add items from new data not present in DOM
      //     for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
      //       if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
      //         mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
      //         shouldRefresh = true;
      //       }
      //     }

      //     // remove items from DOM not present in new data
      //     for (let i = 0; i < mediaGallerySourceItems.length; i++) {
      //       if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
      //         mediaGallerySourceItems[i].remove();
      //         shouldRefresh = true;
      //       }
      //     }

      //     // refresh
      //     if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      //     // if media galleries don't match, sort to match new data order
      //     mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
      //       const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

      //       if (sourceData && sourceData.index !== destinationIndex) {
      //         mediaGallerySource.insertBefore(
      //           sourceData.item,
      //           mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
      //         );

      //         // refresh source now that it has been modified
      //         [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      //       }
      //     });
      //   }

      //   // set featured media as active in the media gallery
      //   this.querySelector(`media-gallery`)?.setActiveMedia?.(
      //     `${this.dataset.section}-${variantFeaturedMediaId}`,
      //     true
      //   );

      //   // update media modal
      //   const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
      //   const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
      //   if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      // }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      // fetchQuantityRules() {
      //   const currentVariantId = this.productForm?.variantIdInput?.value;
      //   if (!currentVariantId) return;

      //   this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
      //   fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
      //     .then((response) => response.text())
      //     .then((responseText) => {
      //       const html = new DOMParser().parseFromString(responseText, 'text/html');
      //       this.updateQuantityRules(this.dataset.section, html);
      //     })
      //     .catch((e) => console.error(e))
      //     .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      // }

      // updateQuantityRules(sectionId, html) {
      //   if (!this.quantityInput) return;
      //   this.setQuantityBoundries();

      //   const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      //   const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      //   for (let selector of selectors) {
      //     const current = this.quantityForm.querySelector(selector);
      //     const updated = quantityFormUpdated.querySelector(selector);
      //     if (!current || !updated) continue;
      //     if (selector === '.quantity__input') {
      //       const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
      //       for (let attribute of attributes) {
      //         const valueUpdated = updated.getAttribute(attribute);
      //         if (valueUpdated !== null) {
      //           current.setAttribute(attribute, valueUpdated);
      //         } else {
      //           current.removeAttribute(attribute);
      //         }
      //       }
      //     } else {
      //       current.innerHTML = updated.innerHTML;
      //     }
      //   }
      // }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      // get productModal() {
      //   return document.querySelector(`#ProductModal-${this.dataset.section}`);
      // }

      get pickupAvailability() { 
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector(`#${this.id} variant-selects`);
      }

      // get relatedProducts() {
      //   const relatedProductsSectionId = SectionId.getIdForSection(
      //     SectionId.parseId(this.sectionId),
      //     'related-products'
      //   );
      //   return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      // }

      // get quickOrderList() {
      //   const quickOrderListSectionId = SectionId.getIdForSection(
      //     SectionId.parseId(this.sectionId),
      //     'quick_order_list'
      //   );
      //   return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      // }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
